import React from 'react';
import { Document, Page, View, Text, Image, StyleSheet } from '@react-pdf/renderer';
import Logo from '../../Tools/logo_iumv.png';

const fmt = (value) =>
  new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(
    Number(value) || 0
  );

const styles = StyleSheet.create({
  page: {
    fontFamily: 'Helvetica',
    fontSize: 8,
    paddingTop: 30,
    paddingBottom: 36,
    paddingHorizontal: 30,
    flexDirection: 'column',
  },
  // Header
  headerRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#cbd5e1',
    paddingBottom: 10,
  },
  logo: {
    width: 90,
  },
  headerRight: {
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  docTitle: {
    fontSize: 13,
    fontFamily: 'Helvetica-Bold',
    color: '#1e3a5f',
    marginBottom: 3,
  },
  headerMeta: {
    fontSize: 7.5,
    color: '#475569',
    marginTop: 2,
  },
  // Summary grid
  summarySection: {
    marginBottom: 10,
  },
  summaryRow: {
    flexDirection: 'row',
    marginBottom: 6,
    gap: 6,
  },
  summaryCard: {
    flex: 1,
    borderWidth: 1,
    borderColor: '#e2e8f0',
    borderRadius: 4,
    backgroundColor: '#f8fafc',
    padding: 6,
  },
  summaryLabel: {
    fontSize: 6.5,
    fontFamily: 'Helvetica-Bold',
    color: '#64748b',
    textTransform: 'uppercase',
    letterSpacing: 0.4,
    marginBottom: 2,
  },
  summaryValue: {
    fontSize: 9.5,
    fontFamily: 'Helvetica-Bold',
    color: '#0f172a',
  },
  summaryValueRed: {
    fontSize: 9.5,
    fontFamily: 'Helvetica-Bold',
    color: '#b91c1c',
  },
  summaryValueGreen: {
    fontSize: 9.5,
    fontFamily: 'Helvetica-Bold',
    color: '#15803d',
  },
  // Status badge
  badgePaid: {
    fontSize: 7,
    fontFamily: 'Helvetica-Bold',
    color: '#166534',
    backgroundColor: '#dcfce7',
    borderRadius: 8,
    paddingHorizontal: 5,
    paddingVertical: 2,
    alignSelf: 'flex-start',
  },
  badgePending: {
    fontSize: 7,
    fontFamily: 'Helvetica-Bold',
    color: '#991b1b',
    backgroundColor: '#fee2e2',
    borderRadius: 8,
    paddingHorizontal: 5,
    paddingVertical: 2,
    alignSelf: 'flex-start',
  },
  // Generation block
  generationBlock: {
    marginBottom: 12,
  },
  generationTitle: {
    fontSize: 9,
    fontFamily: 'Helvetica-Bold',
    color: '#1e3a5f',
    marginBottom: 5,
  },
  // Table
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#e2e8f0',
    borderBottomWidth: 1,
    borderBottomColor: '#cbd5e1',
    paddingVertical: 4,
    paddingHorizontal: 4,
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#e2e8f0',
    paddingVertical: 3,
    paddingHorizontal: 4,
  },
  tableRowAlt: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#e2e8f0',
    paddingVertical: 3,
    paddingHorizontal: 4,
    backgroundColor: '#f8fafc',
  },
  // Column widths — cuotas table
  colCareer:    { flex: 3, fontSize: 7 },
  colCareerH:   { flex: 3, fontSize: 7, fontFamily: 'Helvetica-Bold' },
  colModality:  { flex: 2, fontSize: 7 },
  colModalityH: { flex: 2, fontSize: 7, fontFamily: 'Helvetica-Bold' },
  colQty:       { flex: 1, textAlign: 'right', fontSize: 7 },
  colQtyH:      { flex: 1, textAlign: 'right', fontSize: 7, fontFamily: 'Helvetica-Bold' },
  colGen:       { flex: 2, fontSize: 7 },
  colGenH:      { flex: 2, fontSize: 7, fontFamily: 'Helvetica-Bold' },
  colDate:      { flex: 2, fontSize: 7 },
  colDateH:     { flex: 2, fontSize: 7, fontFamily: 'Helvetica-Bold' },
  colFee:       { flex: 2, textAlign: 'right', fontSize: 7 },
  colFeeH:      { flex: 2, textAlign: 'right', fontSize: 7, fontFamily: 'Helvetica-Bold' },
  colMonthly:   { flex: 2, textAlign: 'right', fontSize: 7 },
  colMonthlyH:  { flex: 2, textAlign: 'right', fontSize: 7, fontFamily: 'Helvetica-Bold' },
  // Column widths — reinscripción table
  colRName:     { flex: 4, fontSize: 7 },
  colRNameH:    { flex: 4, fontSize: 7, fontFamily: 'Helvetica-Bold' },
  colRCurp:     { flex: 3, fontSize: 7 },
  colRCurpH:    { flex: 3, fontSize: 7, fontFamily: 'Helvetica-Bold' },
  colRCareer:   { flex: 3, fontSize: 7 },
  colRCareerH:  { flex: 3, fontSize: 7, fontFamily: 'Helvetica-Bold' },
  colRMode:     { flex: 2, fontSize: 7 },
  colRModeH:    { flex: 2, fontSize: 7, fontFamily: 'Helvetica-Bold' },
  colRCost:     { flex: 2, textAlign: 'right', fontSize: 7 },
  colRCostH:    { flex: 2, textAlign: 'right', fontSize: 7, fontFamily: 'Helvetica-Bold' },
  // Reinscription section title
  sectionTitle: {
    fontSize: 9,
    fontFamily: 'Helvetica-Bold',
    color: '#1e3a5f',
    marginBottom: 5,
    marginTop: 12,
    borderTopWidth: 1,
    borderTopColor: '#cbd5e1',
    paddingTop: 8,
  },
  sectionMeta: {
    fontSize: 6.5,
    color: '#64748b',
    marginBottom: 4,
  },
  // Footer totals
  footerCard: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#f1f5f9',
    borderRadius: 4,
    padding: 7,
    marginTop: 5,
  },
  footerLabel: {
    fontSize: 8,
    fontFamily: 'Helvetica-Bold',
    color: '#334155',
  },
  footerValue: {
    fontSize: 10,
    fontFamily: 'Helvetica-Bold',
    color: '#b91c1c',
  },
});


const PDFEstadoCuenta = ({ selectedMonth, accountStatements, selectedFranchise, students = [], reinscriptionCost = 500 }) => {
  const monthData   = accountStatements?.[selectedMonth];
  const summary     = monthData?.summary || {};
  const generations = monthData?.generations || [];
  const hasReinscription = Number(summary.reinscription || 0) > 0;
  const activeStudents   = students.filter(s => s.status === 'Activo');
  const totalReinscription = activeStudents.length * reinscriptionCost;

  const isPaid = Number(summary.remaining) <= 0;
  const today  = new Date().toLocaleDateString('es-MX', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <Document>
      <Page size="A4" style={styles.page}>

        {/* Header */}
        <View style={styles.headerRow}>
          <Image src={Logo} style={styles.logo} />
          <View style={styles.headerRight}>
            <Text style={styles.docTitle}>Estado de Cuenta</Text>
            <Text style={styles.headerMeta}>
              {selectedFranchise?.short_name || selectedFranchise?.name || ''}
            </Text>
            <Text style={styles.headerMeta}>
              MES: {selectedMonth?.toUpperCase()}
            </Text>
            <Text style={styles.headerMeta}>Fecha de emisión: {today}</Text>
          </View>
        </View>

        {/* Summary row 1: totals breakdown */}
        <View style={styles.summarySection}>
          <View style={styles.summaryRow}>
            <View style={styles.summaryCard}>
              <Text style={styles.summaryLabel}>Total</Text>
              <Text style={styles.summaryValueRed}>{fmt(summary.total_with_late_fee)}</Text>
            </View>
            <View style={styles.summaryCard}>
              <Text style={styles.summaryLabel}>Total del mes</Text>
              <Text style={styles.summaryValue}>{fmt(summary.total_without_retroactive)}</Text>
            </View>
            <View style={styles.summaryCard}>
              <Text style={styles.summaryLabel}>Recargo</Text>
              <Text style={styles.summaryValue}>{fmt(summary.late_fee_total)}</Text>
            </View>
            <View style={styles.summaryCard}>
              <Text style={styles.summaryLabel}>Retroactivo</Text>
              <Text style={styles.summaryValue}>{fmt(summary.retroactive)}</Text>
            </View>
            <View style={styles.summaryCard}>
              <Text style={styles.summaryLabel}>Inscripción</Text>
              <Text style={styles.summaryValue}>{fmt(summary.inscription)}</Text>
            </View>
          </View>

          {/* Summary row 1b: reinscripción — solo cuando aplica */}
          {hasReinscription && (
            <View style={styles.summaryRow}>
              <View style={styles.summaryCard}>
                <Text style={styles.summaryLabel}>Total Reinscripción</Text>
                <Text style={styles.summaryValueRed}>{fmt(totalReinscription)}</Text>
              </View>
              <View style={styles.summaryCard}>
                <Text style={styles.summaryLabel}>Pagado Reinscripción</Text>
                <Text style={styles.summaryValueGreen}>{fmt(summary.paid_reinscription)}</Text>
              </View>
              <View style={styles.summaryCard}>
                <Text style={styles.summaryLabel}>Pendiente Reinscripción</Text>
                <Text style={Number(summary.remaining_reinscription ?? totalReinscription) <= 0 ? styles.summaryValueGreen : styles.summaryValueRed}>
                  {fmt(summary.remaining_reinscription ?? totalReinscription)}
                </Text>
              </View>
              <View style={styles.summaryCard}>
                <Text style={styles.summaryLabel}>Fecha límite Reinsc.</Text>
                <Text style={styles.summaryValue}>{summary.due_date_reinscription || '—'}</Text>
              </View>
              <View style={styles.summaryCard}>
                <Text style={styles.summaryLabel}>Estado Reinscripción</Text>
                <Text style={Number(summary.remaining_reinscription ?? totalReinscription) <= 0 ? styles.badgePaid : styles.badgePending}>
                  {Number(summary.remaining_reinscription ?? totalReinscription) <= 0 ? 'Pagado' : 'Pendiente'}
                </Text>
              </View>
            </View>
          )}

          {/* Summary row 2: payment status */}
          <View style={styles.summaryRow}>
            <View style={styles.summaryCard}>
              <Text style={styles.summaryLabel}>Pagado</Text>
              <Text style={styles.summaryValueGreen}>{fmt(summary.paid)}</Text>
            </View>
            <View style={styles.summaryCard}>
              <Text style={styles.summaryLabel}>Total pendiente</Text>
              <Text style={isPaid ? styles.summaryValueGreen : styles.summaryValueRed}>
                {fmt(summary.remaining)}
              </Text>
            </View>
            <View style={styles.summaryCard}>
              <Text style={styles.summaryLabel}>Fecha límite</Text>
              <Text style={styles.summaryValue}>{summary.due_date || '—'}</Text>
            </View>
            <View style={styles.summaryCard}>
              <Text style={styles.summaryLabel}>Estado</Text>
              <Text style={isPaid ? styles.badgePaid : styles.badgePending}>
                {isPaid ? 'Pagado' : 'Pendiente'}
              </Text>
            </View>
          </View>
        </View>

        {/* Generation tables */}
        {generations.map((generation, idx) => (
          <View key={idx} style={styles.generationBlock}>
            <Text style={styles.generationTitle}>{generation.name}</Text>

            {/* Table header */}
            <View style={styles.tableHeader}>
              <Text style={styles.colCareerH}>CARRERAS SEDE</Text>
              <Text style={styles.colModalityH}>MODALIDAD</Text>
              <Text style={styles.colQtyH}>CANT.</Text>
              <Text style={styles.colGenH}>GENERACIÓN</Text>
              <Text style={styles.colDateH}>INICIO CLASES</Text>
              <Text style={styles.colFeeH}>CUOTA X ALUMNO</Text>
              <Text style={styles.colMonthlyH}>CUOTA MENSUAL</Text>
            </View>

            {/* Table rows */}
            {generation.careers.map((career, careerIdx) => (
              <View
                key={careerIdx}
                style={careerIdx % 2 === 0 ? styles.tableRow : styles.tableRowAlt}
              >
                <Text style={styles.colCareer}>{career.name}</Text>
                <Text style={styles.colModality}>{career.modality}</Text>
                <Text style={styles.colQty}>{career.quantity}</Text>
                <Text style={styles.colGen}>{career.generation}</Text>
                <Text style={styles.colDate}>{career.start_date}</Text>
                <Text style={styles.colFee}>{fmt(career.fee_per_student)}</Text>
                <Text style={styles.colMonthly}>{fmt(career.monthly_fee)}</Text>
              </View>
            ))}
          </View>
        ))}

        {/* Footer — cuotas */}
        <View style={styles.footerCard}>
          <Text style={styles.footerLabel}>TOTAL DE ALUMNOS</Text>
          <Text style={styles.footerValue}>{summary.students_count || 0}</Text>
        </View>
        <View style={[styles.footerCard, { marginTop: 4 }]}>
          <Text style={styles.footerLabel}>TOTAL PENDIENTE CUOTAS</Text>
          <Text style={styles.footerValue}>{fmt(summary.remaining)}</Text>
        </View>

        {/* Reinscripción — solo cuando aplica */}
        {hasReinscription && (
          <>
            <Text style={styles.sectionTitle}>Reinscripción por Alumno</Text>
            <Text style={styles.sectionMeta}>Costo por alumno: {fmt(reinscriptionCost)}</Text>

            {/* Header */}
            <View style={styles.tableHeader}>
              <Text style={styles.colRNameH}>NOMBRE</Text>
              <Text style={styles.colRCurpH}>CURP</Text>
              <Text style={styles.colRCareerH}>CARRERA</Text>
              <Text style={styles.colRModeH}>MODALIDAD</Text>
              <Text style={styles.colRCostH}>COSTO REINSC.</Text>
            </View>

            {/* Rows */}
            {activeStudents.map((student, idx) => (
              <View key={idx} style={idx % 2 === 0 ? styles.tableRow : styles.tableRowAlt}>
                <Text style={styles.colRName}>{student.name}</Text>
                <Text style={styles.colRCurp}>{student.curp}</Text>
                <Text style={styles.colRCareer}>{student.career}</Text>
                <Text style={styles.colRMode}>{student.mode}</Text>
                <Text style={styles.colRCost}>{fmt(reinscriptionCost)}</Text>
              </View>
            ))}
            {activeStudents.length === 0 && (
              <View style={styles.tableRow}>
                <Text style={{ fontSize: 7, color: '#94a3b8' }}>Sin alumnos activos</Text>
              </View>
            )}

            {/* Footer — reinscripción */}
            <View style={[styles.footerCard, { marginTop: 6 }]}>
              <Text style={styles.footerLabel}>ALUMNOS ACTIVOS</Text>
              <Text style={styles.footerValue}>{activeStudents.length}</Text>
            </View>
            <View style={[styles.footerCard, { marginTop: 4 }]}>
              <Text style={styles.footerLabel}>TOTAL REINSCRIPCIÓN</Text>
              <Text style={styles.footerValue}>{fmt(totalReinscription)}</Text>
            </View>
          </>
        )}

      </Page>
    </Document>
  );
};

export default PDFEstadoCuenta;
